// ── Cover Letter Section Editor ───────────────────────────────────────────────
// Formal business letter with date, recipient, body, and signature

import { replaceVariables } from '../../lib/proposalDefaultData';

export default function CoverLetterSection({ data, onChange, variables = {} }) {
  const letter = data || {};

  const update = (key, value) => {
    onChange({ ...letter, [key]: value });
  };

  // Only substitute variables that have actual values (skip empty strings)
  const nonEmptyVars = Object.fromEntries(
    Object.entries(variables).filter(([, v]) => v !== '' && v !== null && v !== undefined)
  );

  // Render variable-replaced preview (empty vars keep {{placeholder}} syntax)
  const renderPreview = (text) => {
    const replaced = replaceVariables(text || '', nonEmptyVars);
    return replaced.split('\n').map((line, i) => (
      <p key={i} className="mb-2 leading-relaxed">{line || '\u00A0'}</p>
    ));
  };

  return (
    <div className="space-y-4">
      {/* Letter Body */}
      <div>
        <label className="block text-xs font-semibold text-[#6b7280] uppercase tracking-wider mb-1">
          Letter Body
        </label>
        <textarea
          value={letter.body || ''}
          onChange={(e) => update('body', e.target.value)}
          placeholder="Write your cover letter..."
          rows={8}
          className="w-full px-3 py-2 text-sm border border-[#e5e4df] rounded-md focus:outline-none focus:ring-1 focus:ring-[#c9a84c] focus:border-[#c9a84c] bg-white leading-relaxed"
        />
        <p className="text-xs text-[#9ca3af] mt-1">
          Use {'{{variables}}'} like {'{{client_name}}'}, {'{{project_name}}'} for dynamic content.
        </p>
      </div>

      {/* Preview */}
      <div className="mt-3">
        <label className="block text-xs font-semibold text-[#6b7280] uppercase tracking-wider mb-2">
          Preview
        </label>
        <div className="bg-white border border-[#e5e4df] rounded-lg p-6 text-sm text-[#2c2c2c]" style={{ minHeight: '200px' }}>
          {/* Date */}
          <div className="text-right mb-6 text-xs text-[#6b7280]">
            {variables.proposal_date || new Date().toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' })}
          </div>

          {/* Recipient */}
          <div className="mb-4 text-xs text-[#2c2c2c] leading-relaxed">
            <div className="font-semibold">{variables.client_contact_person || '{{client_contact_person}}'}</div>
            <div>{variables.client_contact_title || ''}</div>
            <div className="font-semibold">{variables.client_name || '{{client_name}}'}</div>
            {variables.client_address && <div className="text-[#6b7280]">{variables.client_address}</div>}
          </div>

          {/* Salutation */}
          <div className="mb-4 text-xs">
            Dear {variables.client_contact_person || '{{client_contact_person}}'},
          </div>

          {/* Body */}
          <div className="text-xs leading-relaxed">
            {renderPreview(letter.body)}
          </div>

          {/* Signature */}
          <div className="mt-6 text-xs">
            <div className="font-semibold">Yours sincerely,</div>
            <div className="mt-4 font-semibold text-[#1a1a2e]">{variables.company_director || '{{company_director}}'}</div>
            <div className="text-[#6b7280]">{variables.company_director_title || 'Director'}</div>
            <div className="font-semibold text-[#1a1a2e]">{variables.company_name || '{{company_name}}'}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
